import {
  Inject,
  Injectable,
} from 'ng-metadata/core';

import { ApiService } from 'services/api.service';

@Injectable()
export class PopulateService extends ApiService {
  public GW = (<any>window).GW;

  public states: { value: string, label: string }[];
  public countries: { value: string, label: string }[];

  /**
   * Get list of countries
   * country.label {string} Full name of country
   * country.value {string} Country ISO code
   */
  async getCountries() {
    if (this.countries) {
      return this.countries;
    }

    try {
      const response: any = await this.getRequest(`/populate/countries`);
      this.countries = response.data;
      return this.countries;
    } catch (e) {
      throw e;
    }
  }

  /**
   * Get list of USA states
   * state.label {string} Full name of state
   * state.value {string} State ISO code
   */
  async getStates() {
    if (this.states) {
      return this.states;
    }

    try {
      const response: any = await this.getRequest(`/populate/states`);
      this.states = response.data;
      return this.states;
    } catch (e) {
      throw e;
    }
  }

  /**
   * Query Addressy for address predictions from query search
   * @param addressQuery
   */
  async addressyFind(addressQuery: string) {
    const baseUrl = 'https://api.addressy.com/Capture/Interactive/Find/v1.00/json3.ws?';

    const url = [
      `Key=${process.env.MIX_ADDRESSY_KEY}`,
      `Text=${encodeURI(addressQuery)}`,
      `Origin=${this.GW.geoip.iso_code || 'US'}`,
      `Countries=${this.GW.geoip.iso_code || 'US'}`,
      `Limit=10`,
      `Language=en-us`,
    ].join('&');

    try {
      const response: any = await this.$http.get(baseUrl + url);
      return response.data.Items || [];
    } catch (e) {
      throw e;
    }
  }

  /**
   * Lookup Addressy for chosen prediction details for autofill
   * @param addressQuery
   */

  async addressyRetrieve(itemId: string) {
    const baseUrl = 'https://api.addressy.com/Capture/Interactive/Retrieve/v1.00/json3.ws?';

    const url = [
      `Key=${process.env.MIX_ADDRESSY_KEY}`,
      `Id=${itemId}`,
    ].join('&');

    try {
      const response: any = await this.$http.get(baseUrl + url);
      return response.data.Items || [];
    } catch (e) {
      throw e;
    }
  }

  /**
   * Get the default state by IP
   */
  getDefaultState() {
    // setup ip API to call
    const ipApi = false; // false to use gov-api and cache results

    return new Promise((resolve, reject) => {
      // find out user ip, using gov-api can be resolved in the backend
      this.$http.get('https://jsonip.com')
        .then((response) => {
          const ip = response.data['ip'];
          const baseUrl = ipApi
            ? `https://ipapi.co/${ip}/json/`
            : `${this.url}/location/data/${ip}`;

          // get ip location info
          this.$http.get(baseUrl)
            .then((response) => {
              resolve(ipApi ? { status: 'success', data: response.data } : response.data);
            })
            .catch((error) => {
              reject(error);
            });
        })

        .catch((error) => {
          reject(error);
        });
    });
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/services/populate.service.ts